import styled from 'styled-components';

import { DEVICE } from '@hero/constants';

const ProductSelectionSectionWrapper = styled.div(
  ({ isCardWidgetOpen }) => `
    border-radius: var(--size-border-radius-md);
    display: flex;
    flex-direction: ${isCardWidgetOpen ? 'row-reverse' : 'row'};
    gap: 16px;
    position: relative;
  `
);

const ProductListContainer = styled.div`
  flex: 1;
`;

const ProductListBody = styled.div`
  margin: 0 auto;
  max-width: 1024px;

  @media (min-width: 1440px) {
    max-width: 1360px;
  }

  ${DEVICE.tablet.max} {
    max-width: 100%;
  }
`;

const ProductFilterAndSearchContainer = styled.div`
  background: var(--color-bg-weaker);
  border-radius: var(--size-border-radius-md);
  display: flex;
  padding: 16px;
  position: relative;
`;

export {
  ProductFilterAndSearchContainer,
  ProductListBody,
  ProductListContainer,
  ProductSelectionSectionWrapper
};
